module.exports = __webpack_public_path__ + "img/001-man.c04f64a1.svg";